<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
}
.aabb {
  z-index: 9999999 !important;
  border: 1px solid red;
}
.el-tooltip__popper {
  max-width: 20%!important;  //宽度可根据自己需要进行设置
}
</style>
